import React, { useState } from 'react';
import { FilePond, registerPlugin } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css';
// Plugins (optional)
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import './filepond.css';
// Register plugins
registerPlugin(FilePondPluginImagePreview, FilePondPluginFileValidateType);

function FileUploader({ returnFunc = null, slotProps = { filepond: {} } }) {
  const [files, setFiles] = useState([]);

  const onupdatefiles = (fileItems) => {
    // Update state with new file items
    setFiles(fileItems);

    // Call returnFunc for each file item
    if (returnFunc) {
      returnFunc(fileItems);
    }
  };

  return (
    <div className="file-upload" style={{width:'40vw'}}>
      <FilePond
        files={files}
        onupdatefiles={onupdatefiles} // Update the state when files are added or removed
        allowMultiple={true} // Allow multiple files
        maxFiles={5} // Maximum number of files
        name="files" // Name attribute for the input field
        imagePreviewHeight={200}
        credits={false}
        labelIdle='Drag & Drop your files or <span class="filepond--label-action">Browse</span>' // Custom label
        {...slotProps.filepond}
      />
    </div>
  );
}

export default FileUploader;
